import React, { useState } from "react";
import clx from "classnames";
import ActionViewCommentsMobileButton from "../ActionViewComments/ActionViewCommentsMobileButton";
import ActionViewComments from "../ActionViewComments/ActionViewComments";
import { OnCommentAdded } from "../ActionViewComments/CommentForm/CommentForm";
import { ActionComment } from "../../../../types/Action";
import styles from "./ActionViewCommentsContainer.module.css";
import ButtonNoStyles from "../../../common/Buttons/ButtonNoStyles/ButtonNoStyles";
import Icon from "../../../common/Icon/Icon";

interface Props {
    comments?: ActionComment[];
    actionId: string;
    onCommentAdded?: OnCommentAdded;
}

const ActionViewCommentsContainer = ({ comments, actionId, onCommentAdded }: Props) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <div className="flex md:h-full">
            <div className="md:hidden w-full p-1">
                <ActionViewCommentsMobileButton comments={comments || []} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
            </div>
            <div className={clx(styles.commentContainer, { "!bottom-0 !opacity-100": mobileOpen })}>
                <div className="md:hidden absolute top-1.25 right-1.25">
                    <ButtonNoStyles onClick={() => setMobileOpen(false)}>
                        <Icon icon="cross" className="w-1.25 h-1.25" />
                    </ButtonNoStyles>
                </div>
                <ActionViewComments actionId={actionId} comments={comments || []} onCommentAdded={onCommentAdded} />
            </div>
        </div>
    );
};

export default ActionViewCommentsContainer;
